module.exports = __webpack_public_path__ + "static/media/admin_m.9880879a.svg";